import {
  IconBallpen,
  IconCheckbox,
  IconChecklist,
  IconCircleCheck,
  IconClock,
  IconFileCheck,
  IconProgress,
  IconReportMoney,
  IconRocket,
  IconX,
} from "@tabler/icons-react";

export const icons = [
  <IconChecklist key="New-icon" size={20} />,
  <IconRocket key="Ready To Go-icon" size={20} />,
  <IconProgress key="In Progress-icon" size={20} />,
  <IconClock key="Waiting-icon" size={20} />,
  <IconReportMoney key="Quote Sent-icon" size={20} />,
  <IconBallpen key="Signatures Needed-icon" size={20} />,
  <IconX key="IRS Rejected-icon" size={20} />,
  <IconCheckbox key="Ready to E-file-icon" size={20} />,
  <IconFileCheck key="Return Filed-icon" size={20} />,
  <IconCircleCheck key="Completed-icon" size={20} />,
];

export const descriptions = [
  {
    title: "New",
    description: "Clients who have just recently signed up",
  },
  {
    title: "Ready To Go",
    description: "Clients who are ready to have their tax returns filed",
  },
  {
    title: "In Progress",
    description: "Tax return is currently being prepared for filing",
  },
  {
    title: "Waiting",
    description: "Waiting for client's response",
  },
  {
    title: "Quote Sent",
    description:
      "A price estimate for tax preparation services has been sent to the client",
  },
  {
    title: "Signatures Needed",
    description:
      "The client's signature is required to finalize and submit the tax return",
  },
  {
    title: "IRS Rejected",
    description: "The IRS has rejected the tax return submission",
  },
  {
    title: "Ready To E-File",
    description: "The tax return is ready to be e-filed to a tax software",
  },
  {
    title: "Return Filed",
    description: "The tax return has been successfully filed with the IRS",
  },
  {
    title: "Completed",
    description: "Tax returns are filed and payments have been settled",
  },
];

export const UIStatuses = [
  { id: 1, className: "new", color: "#c15800", text: "New" },
  {
    id: 2,
    className: "ready-to-go",
    color: "#2e7d32",
    text: "Ready To Go",
  },
  {
    id: 3,
    className: "in-progress",
    color: "#00477A",
    text: "In Progress",
  },
  {
    id: 4,
    className: "waiting",
    color: "#a78a2e",
    text: "Waiting",
  },
  {
    id: 5,
    className: "quote-sent",
    color: "#0077cc",
    text: "Quote Sent",
  },
  {
    id: 6,
    className: "signatures-needed",
    color: "#dc373a",
    text: "Signatures Needed",
  },
  {
    id: 7,
    className: "irs-rejected",
    color: "#d32f2f",
    text: "IRS Rejected",
  },
  {
    id: 8,
    className: "ready-to-e-file",
    color: "#383794",
    text: "Ready To E-File",
  },
  {
    id: 9,
    className: "return-filed",
    color: "#1976d2",
    text: "Return Filed",
  },
  {
    id: 10,
    className: "completed",
    color: "#176e26",
    text: "Completed",
  },
];
